<template>
  <div class="baoxiuBox">
    <el-card>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-suffix=":"
        class="demo-ruleForm"
      >
        <el-form-item label="类型" prop="taskType">
          <el-select
            v-model="ruleForm.taskType"
            clearable
            placeholder="请选择申请类型"
          >
            <el-option
              v-for="item in taskOption"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictLabel"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input
            v-model="ruleForm.phone"
            type="text"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="captcha" v-if="captchaValidate">
          <el-input
            v-model="ruleForm.captcha"
            type="text"
            style="width: 60%"
            placeholder="验证码"
          ></el-input>
          <button
            :disabled="disabled"
            @click="getYzm"
            type="button"
            class="yzmBtn"
            style="width: 38%"
          >
            {{ msg }}
          </button>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="ruleForm.taskContent"
            maxlength="200"
            :autosize="{ minRows: 6, maxRows: 6 }"
            show-word-limit
            type="textarea"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
        <el-form-item label="上传图片">
          <div class="file">
            <input
              type="file"
              accept="image/*"
              name="uploader-input"
              class="uploader-file"
              @change="getFile"
            />请上传图片
          </div>
        </el-form-item>
      </el-form>
      <div v-for="(item, ind) in imgList" :key="ind" class="imgDiv">
        <b @click="deleteImg(ind)" class="el-icon-error error_icon"></b>
        <img class="imgItemRead avatar" :src="item" alt="" />
      </div>
    </el-card>
    <button
      style="width: 100%"
      class="btn_bind"
      type="button"
      @click="submitForm('ruleForm')"
    >
      立 即 提 交
    </button>
  </div>
</template>

<script>
import { getTaskType, baoxiu, getCaptcha } from "@/api";
import {dataURLtoFilename, validatePhone} from "@/utils";
export default {
  data() {
    return {
      ruleForm: {},
      rules: {
        taskType: [
          { required: true, message: "请选择报修类型", trigger: "change" },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "change" },
          { validator: validatePhone, trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: "请输入验证码", trigger: "change" },
        ],
      },
      taskOption: [
        {
          dictValue: "d_task_single_type_1",
          dictLabel: "不热",
        },
        {
          dictValue: "d_task_single_type_2",
          dictLabel: "漏水",
        },
      ],
      tsjy: [
        {
          dictValue: "d_task_single_type_7",
          dictLabel: "建议",
        },
        {
          dictValue: "d_task_single_type_9",
          dictLabel: "投诉",
        },
      ],
      cw: [
        {
          dictValue: "d_task_single_type_7",
          dictLabel: "测温",
        },
      ],
      value: "",
      imgList: [],
      fileList: [],
      maxtime: 60, //一个小时，按秒计算，自己调整!
      timer: null,
      msg: "获取验证码",
      disabled: false,
      captchaValidate: true,
    };
  },
  mounted() {
    this.getTaskType();
    this.ruleForm.openId = sessionStorage.getItem("thirdId");
    this.ruleForm.userCode = this.$route.query.code;
    this.captchaValidate =
      JSON.parse(sessionStorage.getItem("roles")) &&
      JSON.parse(sessionStorage.getItem("roles")).captchaValidate;
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.category = 0;
          var formdata = new FormData();
          for (let k in this.ruleForm) {
            formdata.append(k, this.ruleForm[k]);
          }
          this.imgList.map((item,ind) => {
            formdata.append("files", dataURLtoFilename(item,'image'+ind));
          });
          baoxiu(formdata).then((res) => {
            this.$toast("报修成功");
            this.$router.go(-1);
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    /**
     * 获取类型
     */
    getTaskType() {
      switch (this.$route.query.type) {
        case '3': this.taskOption  = this.tsjy
              break;
        case '2': this.taskOption = this.cw
              break;
        default: this.taskOption = this.taskOption
      }
    },
    getFile(e) {
      console.log("change", e);
      let file = e.target.files[0];
      this.fileList.push(file);
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        //成功读取文件
        this.imgList.push(e.target.result);
      };
    },
    deleteImg(ind) {
      this.imgList.splice(ind, 1);
    },
    getYzm() {
      var reg_tel = /^(1)\d{10}$/;
      if (!reg_tel.test(this.ruleForm.phone)) {
        this.$toast("请输入正确的手机号码");
        return;
      }
      let params = {
        sysType: 1,
        phone: this.ruleForm.phone,
        companyCode: sessionStorage.getItem("companyCode"),
      };
      getCaptcha(params).then((res) => {
        if (res.code == "0000") {
          this.maxtime = 60;
          this.disabled = true;
          this.timer = setInterval(() => {
            this.CountDown();
          }, 1000);
        }
      });
    },
    CountDown() {
      if (this.maxtime > 0) {
        let seconds = this.maxtime;
        this.msg = +seconds + "s" + "后获取";
        --this.maxtime;
      } else {
        clearInterval(this.timer);
        this.msg = "获取验证码";
        this.disabled = false;
      }
    },
  },
};
</script>
<style  scoped>
.baoxiuBox {
  /* background: #fff; */
  padding: 3% 3%;
  min-height: 90%;
}
.yzmBtn {
  border: 1px solid #c2e7b0;
  border-radius: 3px;
  line-height: 26px;
  background: #f0f9eb;
  color: #67c23a;
  font-size: 12px;
  /*background: #000;*/
}
.baoxiuBox .el-select {
  width: 100%;
}
.uploader-file {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.uploader-file:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 100%;
  height: 178px;
  display: block;
  margin-top: 25px;
}

.file {
  width: 92%;
  height: 30px;
  position: relative;
  display: inline-block;
  background: #fbfdff;
  border: 1px #c0ccda dashed;
  border-radius: 4px;
  padding: 4px 12px;
  overflow: hidden;
  color: #1e88c7;
  text-decoration: none;
  text-indent: 0;
  text-align: center;
  line-height: 30px;
}
.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
}
.file:hover {
  background: #fbfdff;
  border-color: #aadffd;
  color: #004974;
  text-decoration: none;
}
.imgDiv {
  position: relative;
}
.error_icon {
  position: absolute;
  font-size: 25px;
  right: -15px;
  top: -18px;
  z-index: 999999;
  color: #f00;
}
</style>




// WEBPACK FOOTER //
// src/view/ywbl/bx/baoxiu.vue